import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';

@Component({
  standalone: false,
  selector: 'app-edit-journal',
  templateUrl: './edit-journal.component.html',
  styleUrls: ['./edit-journal.component.css']
})
export class EditJournalComponent implements OnInit {
  journalList: any;
  userId: any;
  form: FormGroup | any;
  constructor(public mainService: MainService, private router: Router,
    private activatedroute: ActivatedRoute) { }

  ngOnInit() {
    this.activatedroute.params.subscribe((res) => {
      this.userId = res.id;
    });
    this.form = new FormGroup({
      "question": new FormControl('', Validators.required),
    });
    this.getJournalList();
  }

  // get faq by id
  getJournalList() {
    this.mainService.showSpinner();
    this.mainService.getApi(ApiUrls.view_journalQuestion + `?_id=${this.userId}`, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.journalList = res.result;
        this.form.patchValue({
          question: this.journalList.question
        })
        this.mainService.hideSpinner();
        // this.mainService.successToast(res.responseMessage);
      } else {
        this.mainService.hideSpinner();
        this.mainService.errorToast(res.responseMessage)
      }
    })
  }

  // get faq by id
  updateJournalList() {
    const data = {
      "_id": this.userId,
      "question": this.form.value.question
    }
    this.mainService.showSpinner();
    this.mainService.putApi(ApiUrls.update_journalQuestion, data, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        // this.journalList = res.result;
        this.mainService.hideSpinner();
        this.router.navigate(['journal-mgt'])
        // this.mainService.successToast(res.responseMessage);
      } else {
        this.mainService.hideSpinner();
        this.mainService.errorToast(res.responseMessage)
      }
    })
  }
}
